import store from '@/store'

export default {
  hasAccess (appKey) {
    // Checks if the user has access to the route that has been assigned
    // the app key `appKey`. Simply returns true/false if the user
    // DOES or DOES NOT have access
    let allowAccess = false;
    let userPerms = store.state.auth.userApps;

    userPerms.forEach(function (p) {
      if (p.app_obj.app_key === appKey) {
        allowAccess = true;
      }
    })
    return allowAccess;
  }
}